export default function user (Restangular) {
  'ngInject'
  return Restangular.service('user-profile')
}
